import { CampaignContactsService } from '../services';
import type { OnDuplicate } from '../services';
import type { BulkContactImportRequest } from '../services';
import type { BulkContactImportResponse } from '../services';

export type DuplicateStrategyType = OnDuplicate;
export type ImportContactsCsvPayload = { file: Blob };

export const importContactsJson = (
  campaignId: string,
  payload: BulkContactImportRequest
) => {
  return CampaignContactsService.bulkImportContactsJsonApiCampaignsCampaignIdContactsPost(
    campaignId,
    payload
  );
};

export const importContactsCsv = (
  campaignId: string,
  file: ImportContactsCsvPayload,
  strategy: DuplicateStrategyType = 'skip'
) => {
  return CampaignContactsService.bulkImportContactsCsvApiCampaignsCampaignIdContactsImportPost(
    campaignId,
    file,
    strategy
  );
};

export type { BulkContactImportRequest, BulkContactImportResponse };
